import { useShallow } from 'zustand/shallow';
import AuthenticatedPage from '../../components/authenticated-page';
import { EpisodeItem } from '../../components/episode-item';
import { idToEpisode, usePodcastsStore } from '../../global-state/podcasts';
import { useUserDataStore } from '../../global-state/user-data';
import { usePageTitle } from '../../utils/page-title';

export default function Downloads() {
  usePageTitle('Downloads');
  const downloadedEpisodeIds = useUserDataStore((s) => s.downloadedEpisodeIds);

  // Re-render when downloaded episodes change
  const downloadedEpisodes = usePodcastsStore(
    useShallow(() => downloadedEpisodeIds.map((id) => idToEpisode(id)))
  );

  return (
    <AuthenticatedPage>
      <section class="top-section">
        <h1 class="mb-1 text-xl">Downloads</h1>
        {!downloadedEpisodeIds.length && <p>No episodes have been downloaded</p>}
        {downloadedEpisodes.map((episode) => {
          if (!episode) return null;
          return <EpisodeItem episode={episode} key={episode.id}></EpisodeItem>;
        })}
      </section>
    </AuthenticatedPage>
  );
}
